<template>
  <div class="page-content">
    <div class="search-wrap">
      <div class="search-options-wrap">
        <div class="option-item">
          <div class="option-title">{{ $t('public.status') }}</div>
          <a-select
            allowClear
            showSearch
            v-model="academic"
            style="width: 100%"
            :placeholder="$t('public.academicYear')"
            :dropdownMatchSelectWidth="false"
          >
            <a-select-option
              v-for="(item, index) in academicYearList"
              :key="index"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="search-handles-wrap">
        <a-popconfirm
          placement="topRight"
          :title="$t('public.confirmRead')"
          @confirm="batchReadFun"
        >
          <a-button :loading="readLoading" type="primary" class="margin--right">
            {{ $t('public.read') }}
          </a-button>
        </a-popconfirm>
      </div>
    </div>
    <div class="content-wrap">
      <div class="page-left-right page-left-right--spin">
        <div class="left">
          <a-spin :spinning="loading">
            <div class="search-wrap">
              <a-input-search
                allowClear
                v-model="searchModel"
                :placeholder="
                  $t('public.searchList', {
                    content:
                      $t('public.submitter_lower') +
                      '、' +
                      $t('public.student_lower') +
                      ' ' +
                      $t('public.name_lower'),
                  })
                "
                enter-button
                @search="getDataSouce"
              />
            </div>
            <div class="list-wrap">
              <div
                class="module-item"
                :class="{ 'module-item--selected': item.id == selectedItem.id }"
                v-for="(item, index) in noticeDataSouce"
                :key="index"
                @click="handleSelect(item)"
              >
                <div class="item-dot" v-if="!item.cnt"></div>
                <div class="module-item-content">
                  <div class="module-item-field">
                    <span class="module-item-field-label">
                      {{ $t('public.submitter') }}：
                    </span>
                    {{ item.submitterName }}
                  </div>

                  <div class="module-item-field">
                    <span class="module-item-field-label">
                      {{
                        $t('public.student') + ' ' + $t('public.name_lower')
                      }}：
                    </span>
                    {{ item.studentName }}
                  </div>

                  <div class="module-item-field">
                    <span class="module-item-field-label">
                      {{ $t('public.status') }}：
                    </span>
                    {{
                      $t(
                        $utils.filteApprovalStatus(item.approvalStatus, 'name')
                      )
                    }}
                  </div>
                  <div class="module-item-field">
                    <span class="module-item-field-label">
                      {{ $t('public.scoreType') }}：
                    </span>
                    {{
                      item.type == 1
                        ? 'Regular Grade'
                        : item.type == 2
                        ? 'Semester Exam'
                        : 'Quiz'
                    }}
                  </div>
                </div>
              </div>
            </div>
            <a-pagination
              class="pagination-wrap"
              :showSizeChanger="false"
              hideOnSinglePage
              size="small"
              v-model="current"
              :total="total"
              :pageSize="pageSize"
              @change="currentChange"
            />
          </a-spin>
        </div>
        <div class="right">
          <template v-if="selectedItem.id">
            <a-descriptions size="small" :column="1">
              <a-descriptions-item
                :label="$t('public.student') + ' ' + $t('public.name_lower')"
                >{{ selectedItem.studentName }}</a-descriptions-item
              >
              <a-descriptions-item :label="$t('public.subject')">{{
                selectedItem.courseName
              }}</a-descriptions-item>
              <a-descriptions-item :label="$t('public.scoreType')">{{
                selectedItem.type == 1
                  ? 'Regular Grade'
                  : selectedItem.type == 2
                  ? 'Semester Exam'
                  : 'Quiz'
              }}</a-descriptions-item>
              <a-descriptions-item :label="$t('public.details')">{{
                selectedItem.details
              }}</a-descriptions-item>
              <a-descriptions-item :label="$t('public.status')"
                >{{
                  $t(
                    $utils.filteApprovalStatus(
                      selectedItem.approvalStatus,
                      'name'
                    )
                  )
                }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('public.academicYear')"
                >{{ selectedItem.academic }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('public.semester')">{{
                selectedItem.semester
              }}</a-descriptions-item>

              <a-descriptions-item :label="$t('public.submitter')">{{
                selectedItem.submitterName
              }}</a-descriptions-item>

              <a-descriptions-item
                v-if="selectedItem.approverName"
                :label="$t('public.approver')"
                >{{ selectedItem.approverName }}</a-descriptions-item
              >

              <a-descriptions-item :label="$t('public.submissionTime')">{{
                selectedItem.createTime
              }}</a-descriptions-item>

              <a-descriptions-item
                v-if="selectedItem.updateTime"
                :label="$t('public.approvalTime')"
                >{{ selectedItem.updateTime }}</a-descriptions-item
              >

              <a-descriptions-item :label="$t('public.oldScore')">{{
                selectedItem.oldScore
              }}</a-descriptions-item>

              <a-descriptions-item :label="$t('public.newScore')">{{
                selectedItem.newScore
              }}</a-descriptions-item>
            </a-descriptions>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      academic: undefined,

      searchModel: '',

      pageSize: 10,
      total: 0,
      current: 1,
      loading: false,
      noticeDataSouce: [],
      selectedItem: {},

      readLoading: false,
    }
  },
  computed: {
    ...mapGetters(['academicYearList']),
  },
  watch: {
    academic() {
      this.selectedItem = {}
      this.current = 1
      this.getDataSouce()
    },
  },
  methods: {
    currentChange(pageNumber) {
      this.selectedItem = {}
      this.current = pageNumber
      this.getDataSouce()
    },
    getDataSouce() {
      this.loading = true
      this.$http(this.$api.QUERYRECORDS, {
        academic: this.academic ? this.academic : '',
        userName: this.searchModel,
        pageSize: this.pageSize,
        pageNO: this.current,
      }).then((r) => {
        this.loading = false
        this.total = r.data.total || 0
        this.noticeDataSouce = r.data.rows || []
      })
    },

    updateRecordFun() {
      this.$http(this.$api.UPDATERECORD, {
        id: this.selectedItem.id,
      }).then(() => {
        this.$emit('read')
      })
    },

    batchReadFun() {
      this.readLoading = true
      this.selectedItem = {}
      this.$http(this.$api.BATCHREAD)
        .then(() => {
          this.readLoading = false
          this.$message.success(this.$t('public.readSuccess'))
          this.$emit('read')
          this.current = 1
          this.getDataSouce()
        })
        .catch(() => {
          this.readLoading = false
        })
    },

    // 默认学年学期
    selectYearSemester() {
      const nowTime = new Date()
      const year = nowTime.getFullYear()
      const month = nowTime.getMonth() + 1

      if (month > 8) {
        for (const item of this.academicYearList) {
          if (item.indexOf(year) === 0) {
            this.academic = item
          }
        }
      } else {
        for (const item of this.academicYearList) {
          if (item.indexOf(year - 1) === 0) {
            this.academic = item
          }
        }
      }
    },

    handleSelect(selected) {
      const newSelected = {
        ...selected,
        cnt: (selected.cnt || 0) + 1,
      }
      this.noticeDataSouce = this.noticeDataSouce.map((item) => {
        if (item.id == selected.id) {
          return newSelected
        } else {
          return item
        }
      })
      this.selectedItem = newSelected
      this.updateRecordFun()
    },
  },
  created() {
    // this.selectYearSemester()
    this.getDataSouce()
  },
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';
.page-content {
  height: calc(100% - 56px + 15px);
  margin-bottom: -15px;

  .content-wrap {
    height: calc(100% - 60px);
    margin-left: -15px;
    margin-right: -15px;

    @left: 320px;

    .left {
      width: @left;

      .module-item {
        background-color: #fff;
        padding: 12px;
        margin: 0 0 12px;
        border-radius: 6px;
        border: 1px solid @lineColor;
        cursor: pointer;
        position: relative;

        .item-dot {
          position: absolute;
          width: 12px;
          height: 12px;
          background-color: #f5222d;
          border-radius: 50%;
          box-shadow: 0 0 0 1px #fff;
          right: 0;
          top: 0;
          transform: translate(50%, -50%);
          transform-origin: 100% 0px;
        }

        line-height: 1.6;
      }

      .module-item--selected {
        border: 1px solid @themeColor;
      }
    }

    .right {
      width: calc(100% - @left);
      height: 100%;
      overflow-y: auto;
      padding: 12px;
    }
  }
}
</style>
